import React from "react";
import "./Features.css";
import { FaSearch, FaCompass, FaChartLine, FaBuilding } from "react-icons/fa";
import { Link } from "react-router-dom";

const features = [
  {
    icon: <FaSearch />,
    title: "Job search",
    highlight: "Find a job",
    link: "/ebench/jobs",
  },
  {
    icon: <FaCompass />,
    title: "Career planning",
    highlight: "Choose a career",
    link: "#",
  },
  {
    icon: <FaChartLine />,
    title: "Market information",
    highlight: "Explore opportunities",
    link: "#",
  },
  {
    icon: <FaBuilding />,
    title: "Hiring",
    highlight: "Fill a position",
    link: "#",
  },
];

const Features = () => {
  return (
    <section className="features">
      <div className="features-container">
        {features.map((item) => (
          <Link to={item.link} key={item.link} className="feature-link">
            <div className="feature-card">
              <div className="feature-icon">{item.icon}</div>
              <div className="feature-text">
                <span>{item.title}</span>
                <h4>{item.highlight}</h4>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
};

export default Features;
